import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, DocumentService, DossierService, DroitsService, InstructionService, StateService } from '../../../../../services'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { first } from 'rxjs/operators'

const KEY = 'upload-file-dialog'

@Component({
	selector: 'atyl-upload-file-dialog',
	templateUrl: './upload-file-dialog.component.html',
	styleUrls: ['./upload-file-dialog.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/layout/dialogs/upload-file-dialog',
	key: KEY,
})
export class UploadFileDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any

	@ViewChild('drawer', { static: false }) drawer: MatDrawer
	config: any = {
		placeholder: 'Commentaire',
		height: '5vh',
		toolbar: [
			['style', ['bold', 'italic', 'underline']],
			['para', ['ul', 'ol', 'paragraph', 'height']],
			['insert', ['table']]
		],
		disableDragAndDrop: true
	};
	instruction:any;
	
	formulaires: any[] = [];
	states: any[]
	result: any = {
		currentEtat: '0',
		archive: 'false',
		selectedFormulaire: null,
		document: null,
		selectedDocument: null,
		selectedFormulaires: [],
		selectedInterventions: [],
		GED: false,
	};
	typeDocuments: any
	notUploaded: boolean = true;
	nomDoc: string = '';
	showSlider: boolean = false;
	sliderConfig: any
	sliderData: any = {
		formulaires: [],
		interventions: [],
		formulaires_group: []
	};
	formulairesControl: FormControl = new FormControl([]);
	interventionsControl: FormControl = new FormControl([]);
    isEditable: boolean = true;
	showGEDButton: boolean = false;
    
    droits: any = [];
    droitsObjets: any;
	
	typeDocumentsDoc: any[]=[]

	default: any = false;

	document: any;
	instructions: any = [];

	originSelectedInstruction: any
	selectedInstruction: any;

	isCreating: boolean = true;

	constructor(
		public dialogRef: MatDialogRef<UploadFileDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,
		public droitsService: DroitsService,
		private snackbar: MatSnackBar,
		changeDetectorRef: ChangeDetectorRef,
		private documentService: DocumentService,
		private dossierService: DossierService,
		private instructionService: InstructionService,
		dialogService: DialogService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		console.log("AAAA upload", this.data)

		if (this.data.formulaires) {
			this.formulaires = this.data.formulaires
		}
		if (this.data.instruction!=undefined && this.data.instruction) {
            this.instruction = this.data.instruction
        }
		if (this.data.droits!=undefined && this.data.droits) {
            this.droits = this.data.droits
        }
        if (this.data.droitsObjets!=undefined) {
            this.droitsObjets = this.data.droitsObjets
        }
		
		if (this.data.document != undefined && this.data.document) {
			this.isCreating = false;

			this.result.selectedDocument = this.data.document
			//this.result.selectedDocument.value = this.data.document
			//if (this.result.selectedDocument.value) {
				this.result.selectedDocument.value.datedebut=this.result.selectedDocument.datedebut;
				this.result.selectedDocument.value.datefin=this.result.selectedDocument.datefin;
				this.result.selectedDocument.value.descriptiion=this.result.selectedDocument.descriptiion;
			//}
			
			this.result.document = this.data.document.document
			this.documentCanBeSentGED(this.result.document);
			this.notUploaded = false
			console.log('UploadFileDialogComponent',this.result);
			
			if (this.data.document.editable != undefined)
            	this.isEditable = this.data.document.editable;
			if(this.data.isEditable != undefined && !this.data.isEditable)
				this.isEditable = false;
			console.log("UploadFileDialogComponent ducment",this.data.document,this.isEditable, this.result.selectedDocument);
		}
		this.loadTypes();
		//this.loadTmpFile();
		this.__createSideBar__();
		
  
		let id = this.sliderConfig.dossier.ID
		this.dossierService.getinstructionlist(id).pipe(first()).subscribe((r: JSONRpcResponse) => {
			this.instructions = r.result.instructions;  
			
			this.changeDetectorRef.detectChanges();    
		})
		
		let _options = {
			document: this.result.selectedDocument,
		}
		this.instructionService.getBy("document",_options).subscribe((r: JSONRpcResponse) => {
			if (r.result.length > 0) {
				this.selectedInstruction = r.result[0].ID;
				this.originSelectedInstruction = r.result[0].ID;
			} else {
				this.selectedInstruction = 0;
				this.originSelectedInstruction = 0;
			}
			
			this.changeDetectorRef.detectChanges();    
		})

        this.changeDetectorRef.detectChanges();
	}

	ngOnDestroy() {
		this.result = null
	}

	
	loadTmpFile() {
		let _opts={
			
		};
		this.documentService.getListDocumentsTemp(_opts).subscribe((res: JSONRpcResponse) => {
			console.log("loadTmpFile",res);
		
		});
	}
	
	loadTypes() {
		// this.result.selectedDocument['document']=[];
        let demande_type="DOSSIER";
        
        if (this.instruction!=undefined && this.instruction) {
            console.log("document instruction",this.instruction);
            demande_type=this.instruction.demande.type.ID;
          }   
		this.documentService.getDocumentsType(demande_type).subscribe((res: JSONRpcResponse) => {

			this.typeDocuments = []
			this.typeDocumentsDoc=[];
			/*   if (this.result.selectedDocument) {
				  res.result.forEach(doc => {
					  this.typeDocuments.push(doc.document);
				  }
				  );

			}
			else*/
			this.typeDocuments = res.result
			for(let i=0;i<this.typeDocuments.length;i++) {
			 let d:any=this.typeDocuments[i];
			  d.readAndAdd=true;
			  if ( 
				  d.document !=undefined 
				  && d.document.type !=undefined 
			  && d.document.type.key !=undefined 
			   && d.document.type.key
			  && this.droits[d.document.type.key]!=undefined
			  && this.droits[d.document.type.key].c!=undefined	
			  )
			  d.readAndAdd=this.droits[d.document.type.key].c;
              this.setObjectUserRights(d,"document");
			  this.typeDocumentsDoc.push(Object.assign({}, d));
		  } 
		  console.log('UploadFileDialogComponent',this.droits,this.typeDocuments,this.typeDocumentsDoc)


			setTimeout(() => {
				if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
					this.changeDetectorRef.detectChanges()
				}
			})
		})

	}


	uploadFile(event, documentselected) {
		const element = event[0]
		if (this.checkFileSize(element.size, 25)) {
			this.result.selectedDocument.wrongsize = false
			this.documentService.uploadDocument(element).subscribe((res: any) => {
				if (res.success) {
					this.result.selectedDocument.uploaded = true
					this.notUploaded = false
					this.result.selectedDocument.value = res
					this.result.selectedDocument.value.description = this.result.selectedDocument.description
					this.result.selectedDocument.libelle = this.result.selectedDocument.value.file
					this.result.selectedDocument.value.libelle = this.result.selectedDocument.value.file
					this.result.selectedDocument.value.datedebut = new Date();

					if (this.isCreating && this.selectedInstruction && this.instructions && this.instructions.length > 0) {
						const demande = this.instructions.find((i: any) => i.ID == this.selectedInstruction)
			
						if (!demande) return

						this.result.selectedDocument.demandeID = demande.demande.ID;
					}
				} else {
					this.snackbar.open("Erreur Importation document", '', {
						duration: 2500,
						panelClass: ['error-snackbar']
					});
				}
			})
			console.log("selectedDoc",this.result)
		}
		else {
			this.snackbar.open(this.strings.errors.sizeExceeded, '', {
				duration: 2500,
				panelClass: ['error-snackbar']
			})
		}
	}

	getDocumentClick(document: any) {
		console.log("getDocument getDocumentClick",document,this.typeDocumentsDoc)
		this.result.selectedDocument.document=Object.assign({}, document);;
		this.documentCanBeSentGED(document);
		if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
							this.changeDetectorRef.detectChanges()
		}
	}
	
	getDocument(document: any) {
		if (Number.isInteger(document)) {
				let parms:any[]=[];
				for(let i=0;i<this.typeDocuments.length;i++) {
					 let d:any=this.typeDocuments[i];
					 
					 if (d.document!=undefined 
						&& d.document.ID!=undefined  
						&& d.document.ID==document
						&& d.document.parameter!=undefined
					 )
					 parms=d.document.parameter;
					
				}
				
				if (this.result.selectedDocument.document!=undefined 
							&& this.result.selectedDocument.document.parameter!=undefined
							 )
							 this.result.selectedDocument.document.parameter=parms;	 
			 console.log("getDocument document",document,parms, this.result.selectedDocument)
			this.changeDetectorRef.detectChanges();
		}
		/*
		if (!this.result.selectedDocument) {
		 this.result.selectedDocument={
			ID:0,
			description:null,
			value:{}
			};
		  }



		this.result.selectedDocument.document=document;
		*/
	}

	checkFileSize(fsize: any, sizelimit: any) {
		const file = (fsize / ONE_MB_IN_BYTES).toFixed(2)
		if (file >= sizelimit)
			return false
		else
			return true
	}

	private __createSideBar__() {
        console.log('this.dataImporte:',this.data,' et selectedDocument:',this.result.selectedDocument );
		if (this.data && this.data.slider && this.data.slider.enabled) {
			this.showSlider = (this.result.selectedDocument && this.result.selectedDocument.state === 1) || this.result.selectedDocument === null
			this.sliderConfig = this.data.slider
			this.showSlider && this.__generateSliderData__()
		}
		setTimeout(() => {
			if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
				this.changeDetectorRef.detectChanges()
			}
		})
	}
	private __generateSliderData__() {
		if (this.sliderConfig.components.formulaires) {
			let _opts:any={
				getAll:true,
				/*noinstruction: true,
				declenche: false,
				getInstruction: false,*/
			}
			
			this.dossierService.getformulairelist(this.sliderConfig.dossier.ID,_opts).subscribe((res: JSONRpcResponse) => {
				if (res.result) {
						this.sliderData.formulaires = res.result
						
					if (this.sliderData.formulaires.length>0) {
						let grp:any={};
						for(let i=0;i<this.sliderData.formulaires.length;i++) {
							let f:any=this.sliderData.formulaires[i];
							if (grp[f.form.libelle]==undefined) {
								grp[f.form.libelle]={
									label:f.form.libelle,
									formulaires: []
								}
								
							}
							grp[f.form.libelle].formulaires.push(f);
							
						}
						
						let grps:any[]=[];
						let labels:any[]=Object.keys(grp).sort();
						for(let i=0;i<labels.length;i++) {
							grps.push(grp[labels[i]]);
						}
						this.sliderData.formulaires_group=grps;
						
					}	
					console.log("UploadFileDialogComponent __generateSliderData__",this.sliderData)
					
					if (this.result && this.result.selectedDocument) {
						this.documentService.getFormulairesByDocument(this.result.selectedDocument.ID).subscribe((res: JSONRpcResponse) => {
							console.log(res)
						})
	                    console.log("this.result.selectedDocument.ID:",this.result.selectedDocument.ID);
						this.documentService.getInterventionsByDocument(this.result.selectedDocument.ID).subscribe((res: JSONRpcResponse) => {
							//console.log(res.result.inludes(142))
							this.sliderData.interventions.filter((intervention: any) => res.result.inludes(intervention))
						})
					}
				}
			})
		}
		if (this.sliderConfig.components.interventions) {
			this.sliderData.interventions = this.sliderConfig.dossier.suivis
		}
	}

	toggleDrawer() {
		this.drawer.toggle()
	}

    
    setObjectUserRights(obj: any | any[], type: string) {
        if (Array.isArray(obj)) {
            obj.forEach((item: any) => {
                item = this.applyRightsObj(item, type);
            });
        } else {
            obj = this.applyRightsObj(obj, type);
        }
        return obj;
    }
    
    applyRightsObj(obj: any, type: string) {
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        
        switch (type) {
            case "document":
				if (obj.document!=undefined && obj.document.type!=undefined )
                	key = obj.document.type.key;
                break;
        }
    
        if (this.droitsObjets != undefined && this.droitsObjets[type] != undefined) {
            if (this.droitsObjets[type][key] != undefined) {
                rg = this.droitsObjets[type][key];
            }
        }
    
        obj.droitsObjets = rg;
    
        // Si l'objet est éditable, vérifier s'il est modifiable
        if (obj.editable) {
            obj.editable = rg.w;
        }
        return obj;
    }

	documentCanBeSentGED(document) {
		this.showGEDButton = false;
		if (document && document.type && document.type.parametre) {
			for (const [key, value] of Object.entries(document.type.parametre)) {
				if (key.toLowerCase() == "ged" && value) {
					this.showGEDButton = true;
				}
			}
		}
	}
	
	selectInstruction(event: any) {
		console.log("select instruction", this.selectedInstruction)
	}

	onSave() {
		let _options = {
			document: this.result.selectedDocument,
		}; 

		if (!this.isCreating && this.originSelectedInstruction !== this.selectedInstruction) {
			const instruction = this.instructions.find((i: any) => i.ID == this.selectedInstruction)

			if (instruction) {
				this.result.selectedDocument.demandeID = instruction.demande.ID;

				_options.document.demandeID = instruction.demande.ID;
			} else if (!instruction && this.selectedInstruction === 0) {
				this.result.selectedDocument.demandeID = 0;
			}


			this.instructionService.change(this.selectedInstruction, "document", _options).subscribe((res: JSONRpcResponse) => {
				if (res.result) {
					console.log('set result', res.result);
					// this.dialogRef.close(true);
					this.changeDetectorRef.detectChanges(); 
				}
			})
		} else if (this.isCreating && this.instructions && this.instructions.length > 0) {
			const instruction = this.instructions.find((i: any) => i.ID == this.selectedInstruction)

			if (!instruction) return

			// this.result.selectedDocument.demandeID = 0;
			this.result.selectedDocument.demandeID = instruction.demande.ID;
		}
	}
}
